{
  "configApiTerraformCta": "Programmatically manage account configuration via <a target='_blank' href='https://docs.$t(common:defaultHost)/log-analysis-api/ref#tag-configuration'>API</a> or <a href='https://docs.$t(common:defaultHost)/docs/terraform-provider' target='_blank'>Terraform</a>."
}
